import React, { useCallback, useEffect, useMemo } from "react";
import { logout } from "../../../redux/Slices/Auth";
import { useDispatch } from "react-redux";
import authHeader from "../../../services/authHeader";
import { persistor } from "../../../redux/store";
import TopBar from "./TopBar";
import BottomNav from "./BottomNav";
import { getCurrentUser } from "../../../services/commonService";
const Header = () => {
  const [current, changeCurrent] = React.useState("home");
  const pathname = window.location.pathname.replace("/", "");
  useEffect(() => {
    if (pathname === "") {
      changeCurrent("/");
    } else if (pathname === "settings") {
      changeCurrent("settings");
    } else if (pathname.includes("processing")) {
      changeCurrent("processing");
    } else {
      changeCurrent(pathname);
    }
  }, [pathname, current]);
  const dispatch = useDispatch();
  const currentUser = useMemo(() => getCurrentUser()?.data, []);

  useEffect(() => {
    if (!currentUser) {
      dispatch(logout());
    }
  }, [currentUser])

  const logOut = useCallback(async () => {
    await persistor.purge();
    await persistor.flush();
    dispatch(logout());
  }, [dispatch]);
  function handleClick(e) {
    let token = authHeader();
    if (token === "") {
      dispatch(logout());
    }
    changeCurrent(e.target?.name);
  }
  return (
    <header className="sticky-header">
      <TopBar logOut={ logOut } />
      <div className="d-sm-block d-none">
        <BottomNav handleClick={ handleClick } />
      </div>
    </header>
  );
};
export default Header;
